import { Component, OnInit, Inject, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogPortfolioMultieditViewGridLayoutService } from '@irb/irb-dialogs/dialog-portfolio-multiedit-view/dialog-portfolio-multiedit-view.grid-layout.service';
import { PortfolioService } from '@irb/irb-clients/portfolios/portfolio.service';
import { Portfolio } from '@irb/irb-clients/irb-clients.model';
import { IMultiplePortfolioEditRequest } from "@irb/irb-clients/irb-clients.model";

export interface DialogPortfolioMultieditViewConfig {
  data: IMultiplePortfolioEditRequest;
}

@Component({ standalone: false,
  selector: 'irb-dialog-portfolio-multiedit-view',
  templateUrl: './dialog-portfolio-multiedit-view.component.html',
  styleUrls: ['./dialog-portfolio-multiedit-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DialogPortfolioMultieditViewComponent implements OnInit {
  gridOptions: any;
  grid: any;
  footerContent: string;
  data: Array<number> = [];
  hasServerSideDatasource: boolean = false;
  overlayType: any;
  _portfolios: Array<Portfolio> = [];
  multiplePortfolioEditRequest: IMultiplePortfolioEditRequest;
  frameworkComponents: any;
  loadingOverlayComponentParams: any;
  private showClearFilters: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogPortfolioMultieditViewComponent>, 
    @Inject(MAT_DIALOG_DATA) public mdd: DialogPortfolioMultieditViewConfig,
    private gls: DialogPortfolioMultieditViewGridLayoutService,
    private pfs: PortfolioService) {
      this.multiplePortfolioEditRequest = mdd.data;
      this.multiplePortfolioEditRequest.baseFilter = this.multiplePortfolioEditRequest.filter;
    }
  
  get portfolios() {
    return this._portfolios;
  }

  set portfolios(portfolios: any) {
    this._portfolios = portfolios;
  }

  ngOnInit(): void {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(this),
      floatingFilter: true,
      context: { componentParent: this },
      rowModelType: 'serverSide',
      getRowId: (params: any) => {
        return params.data.portfolioName;
      }
    };
    this.frameworkComponents = this.gls.getFrameworkComponents();
    this.loadingOverlayComponentParams = {parentObject: this};
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
    this.footerContent = this.multiplePortfolioEditRequest.portfolioCount + " Portfolios";
    this.grid.api.setGridOption("serverSideDatasource",this.setDatasource());
  }

  setDatasource() {
    this.hasServerSideDatasource = true;

    return {
      getRows: (params: any) => {
        this.overlayType = 'loading';
        this.grid.api.showLoadingOverlay();
       
        this.pfs.getMultieditSelection(params, this.multiplePortfolioEditRequest).subscribe((data: any) => {
          if(data?.length > 0) {
            this.portfolios = <Portfolio[]>data;
            params.success({rowData: this.portfolios});          
            this.grid.api.hideOverlay();
          } else {
            this.showClearFilters = this.multiplePortfolioEditRequest.filter?.length > 0;
            this.grid.api.showNoRowsOverlay();
          }          
        });
      }
    };
  }
}
